import React from 'react'
import style from './login.css'
import * as urls from './common/urls'
import axios from 'axios';
import Cookies from 'universal-cookie';
import { domain } from "./common/urls";

const cookies = new Cookies();
// const Login = () => {

class PartnerLogin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            error: '',
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        axios.post(urls.getLoginPath(), {
            username: this.state.username, 
            password: this.state.password,
        }).then(res => {
            cookies.set('auth_token', res.data.access, {path: '/', maxAge: '604800', domain: domain});
            cookies.set('user_role', 'partner', {path: '/', maxAge: '604800', domain: domain});
            window.location.href = '/';
        }).catch(err => {
            err.response 
                ? this.setState({error: err.response.data.detail})
                : console.log(err);
        })
    }

    render = () => {
    return (<>
    <div id="back">
        <canvas id="canvas" class="canvas-back"></canvas>
        <div class="backRight">    
        </div>
        <div class="backLeft">
        </div>
    </div>

<div id="slideBox">
  <div class="topLayer">
    <div class="right">
      <div class="content">
        <h2>Partner Login</h2>
        <form id="form-login" method="post" 
        onSubmit={this.handleSubmit}
        // onsubmit="return false;"
        >
          <div class="form-element form-stack">
            <label for="username-login" class="form-label">Work Email</label>
            <input id="username-login" type="email" name="username" value={this.state.username} autoFocus={true}
            onChange={e => this.setState({username: e.target.value})} />
          </div>
          <div class="form-element form-stack">
            <label for="password-login" class="form-label">Password</label>
            <input id="password-login" type="password" name="password" value={this.state.password} 
            onChange={e => this.setState({password: e.target.value})} />
            {/* <a href="mailto:contac@unicreds.com" style={{textAlign:"right",margin:"1em 0em",color:"#f05c4d"}}>Forgot Password</a> */}
          </div>
          <div class="form-element form-submit">
            <button id="logIn" class="login" type="submit" name="login">Log In</button>
            {/* <button id="goRight" class="login off" name="forgotPassword">Forgot Password</button> */}
          </div>
          <div className='mt-3 text-red'><p>{this.state.error}</p></div>
        </form>
      </div>
    </div>
  </div>
</div>
</>
);
// }
}
}

class LoginPage extends React.Component {
    render() {
        return (
            <PartnerLogin />
            // <div className='container my-5'>
            //     <Col md={{span: 4, offset: 4}} className='my-5'>
            //     </Col>
            // </div>
        )
    }
}


export default LoginPage;
